import LocationOn from '@ixigo/icons/LocationOnFilled';
import type { TimelineItem } from './hooks/useTimelineItems';
import { CabFilled } from './icons';

export const TimelineIndicator = ({ item }: { item: TimelineItem }) => {
	switch (item.iconType) {
		case 'location':
			return <LocationOn className="size-20 shrink-0 text-secondary" />;
		case 'cab':
			return <CabFilled className="size-20 shrink-0 text-secondary" />;
		default:
			return <LocationOn className="size-20 shrink-0 text-secondary" />;
	}
};
